import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/noFound.png'



export default /*@__PURE__*/_defineComponent({
  __name: 'NotFound',
  props: {
  marginTop: {
    type: String,
    default: "160",
  },
  marginBottom: {
    type: String,
    default: "0",
  },
  emptyText: {
    type: String,
    default: "暂无数据",
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "no-found",
    style: _normalizeStyle({ 'padding-top': props.marginTop + 'px', 'padding-bottom': props.marginBottom + 'px' })
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      src: _imports_0,
      alt: "",
      srcset: ""
    }, null, -1)),
    _createElementVNode("div", null, _toDisplayString(__props.emptyText), 1)
  ], 4))
}
}

})